import React from "react";

const STAGE = {
  "Registration": "bg-slate-100 text-slate-700 border-slate-300",
  "Profile Completion": "bg-slate-100 text-slate-700 border-slate-300",
  "Documents": "bg-blue-50 text-blue-700 border-blue-200",
  "Document Verification": "bg-blue-50 text-blue-700 border-blue-200",
  "Screening": "bg-sky-50 text-sky-700 border-sky-200",
  "Interview": "bg-sky-50 text-sky-700 border-sky-200",
  "Selection": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Offer": "bg-violet-50 text-violet-700 border-violet-200",
  "Signed Offer": "bg-violet-50 text-violet-700 border-violet-200",
  "Medical": "bg-teal-50 text-teal-700 border-teal-200",
  "MOL / Contract": "bg-amber-50 text-amber-700 border-amber-200",
  "Visa / Processing": "bg-amber-50 text-amber-700 border-amber-200",
  "Joining / Ticket": "bg-purple-50 text-purple-700 border-purple-200",
  "Deployment": "bg-emerald-100 text-emerald-800 border-emerald-300 font-semibold",
};

const STATUS = {
  "New": "bg-sky-50 text-sky-700 border-sky-200",
  "Deployed": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Verified": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Active": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Approved": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "PASS/FIT": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "FIT": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Paid": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Completed": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Under Review": "bg-amber-50 text-amber-700 border-amber-200",
  "Pending": "bg-amber-50 text-amber-700 border-amber-200",
  "Scheduled": "bg-amber-50 text-amber-700 border-amber-200",
  "Issued": "bg-blue-50 text-blue-700 border-blue-200",
  "Partially Paid": "bg-amber-50 text-amber-700 border-amber-200",
  "Processing": "bg-blue-50 text-blue-700 border-blue-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  "Uploaded": "bg-blue-50 text-blue-700 border-blue-200",
  "Rejected": "bg-rose-50 text-rose-700 border-rose-200",
  "FAIL/UNFIT": "bg-rose-50 text-rose-700 border-rose-200",
  "Overdue": "bg-rose-50 text-rose-700 border-rose-200",
  "Expired": "bg-rose-50 text-rose-700 border-rose-200",
  "Cancelled": "bg-slate-100 text-slate-600 border-slate-200",
  "Selected": "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function StatusBadge({ value, kind = "status" }) {
  if (!value) return <span className="text-slate-400 text-xs">—</span>;
  const map = kind === "stage" ? STAGE : STATUS;
  const cls = map[value] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`badge-${String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap ${cls}`}
    >
      {value}
    </span>
  );
}
